import { UserManager } from 'oidc-client';
import React from 'react';
import { render } from 'react-dom';
import ulog from 'ulog';
import App from './App';
import AppLoader, { getAppConfig } from './AppLoader';
import './index.css';

// Sets global logging levels
ulog.level = process.env.NODE_ENV === 'development' ? ulog.DEBUG : ulog.ERROR;

const params = new URLSearchParams(window.location.search);
const navToken = params.get('nav');
if (navToken) {
	localStorage.setItem('navToken', navToken);
	// Remove nav token from URL after storing it
	const url = new URL(window.location.href);
	url.searchParams.delete('nav');
	window.history.replaceState({}, document.title, url.pathname + url.search);
}

/**
 * Fast-path redirect for BarracudaONE navigation.
 * When a nav token is present but no OIDC session exists, skip loading the
 * entire React app and redirect to the OIDC provider immediately.
 * This avoids two full SPA loads before the OIDC redirect, saving ~9s for
 * high-latency regions (e.g. Australia).
 */
function shouldFastRedirect(): boolean {
	if (!navToken) {
		return false;
	}
	// oidc-client stores the user in localStorage with key: oidc.user:<authority>:<client_id>
	const hasOidcSession = Object.keys(localStorage).some((key) =>
		key.startsWith('oidc.user:'),
	);
	return !hasOidcSession;
}

function showSigningInIndicator() {
	const mainEl = document.getElementById('main');
	if (mainEl) {
		mainEl.innerHTML = `
      <div style="display:flex;flex-direction:column;justify-content:center;align-items:center;height:100vh;font-family:Roboto,sans-serif;color:#555">
        <div style="width:40px;height:40px;border:3px solid #e0e0e0;border-top:3px solid #1976d2;border-radius:50%;animation:di-spin 1s linear infinite"></div>
        <p style="margin-top:16px;font-size:14px">Signing you in...</p>
      </div>
      <style>@keyframes di-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}</style>
    `;
	}
}

if (shouldFastRedirect()) {
	showSigningInIndicator();
	getAppConfig()
		.then((config) => {
			const userManager = new UserManager({
				authority: config.oidcAuthority,
				client_id: 'webui',
				redirect_uri: config.oidcRedirectUri,
				response_type: 'code',
				scope: 'frontendapi openid',
			});
			userManager.signinRedirect({ acr_values: ['idp:microsoft'] });
		})
		.catch((err) => {
			console.error(
				'[DI-FastRedirect] Config fetch failed — falling back to normal app flow',
				err,
			);
			renderApp();
		});
} else {
	renderApp();
}

function renderApp() {
	render(<AppLoader app={App} />, document.getElementById('main'));
}
